<template>
  <div>
    <a
      ref="contextLink"
      class="header__filter-link"
      :class="{
        'active active--purple': view.group_bys.length > 0,
      }"
      @click="$refs.context.toggle($refs.contextLink, 'bottom', 'left', 4)"
    >
      <i class="header__filter-icon iconoir-book-stack"></i>
      <!-- Origem Flow: com um único agrupamento o pill mostra o NOME do
           campo ("Status"), como o toggle de agrupar do ClickUp. -->
      <span class="header__filter-name">{{ groupByLabel }}</span>
    </a>
    <ViewGroupByContext
      ref="context"
      :database="database"
      :view="view"
      :fields="fields"
      :read-only="readOnly"
      :disable-group-by="disableGroupBy"
      :store-prefix="storePrefix"
      @changed="$emit('changed')"
    ></ViewGroupByContext>
  </div>
</template>

<script>
import ViewGroupByContext from '@baserow/modules/database/components/view/ViewGroupByContext'

export default {
  name: 'ViewGroupBy',
  components: { ViewGroupByContext },
  props: {
    database: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    view: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
    disableGroupBy: {
      type: Boolean,
      required: false,
      default: false,
    },
    storePrefix: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['changed'],
  computed: {
    groupByLabel() {
      if (this.view.group_bys.length === 1) {
        const field = this.fields.find(
          (f) => f.id === this.view.group_bys[0].field
        )
        if (field) {
          return field.name
        }
      }
      return this.$t('viewGroupBy.groupBy', {
        count: this.view.group_bys.length,
      })
    },
  },
}
</script>
